import Viewer from '../preview/index'

export default (Vue) => {
    const createImageViewer = function(options = {}) {
        const ImageViewer = Vue.extend(Viewer)
        let imageViewer = new ImageViewer()
        imageViewer.data = options.data
        imageViewer.index = options.index ? options.index : 0
        imageViewer.fieldNames = Object.assign(imageViewer.fieldNames, options.fieldNames)
        imageViewer.immediate = options.immediate
        let vm
        if (!imageViewer.$el) {
          vm = imageViewer.$mount()
          document.querySelector('body').appendChild(vm.$el)
        }
        imageViewer.$on('destroy', () => {
            if (vm) document.querySelector('body').removeChild(vm.$el)
        })
        return imageViewer
    }
    return createImageViewer
}



// WEBPACK FOOTER //
// ./src/components/framework/functional/image-preview.js